const currencyToInt = (currency: string) => {
  return parseInt(currency.replace(/[$,]+/g, ""));
};

export default currencyToInt;
